'use client'

import { Text } from '@vinted/web-ui'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/shared/utils'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import {
  userClickFaqRelatedQuestionEvent,
  HelpCenterQuestionModel,
} from '@marketplace-web/help-center/help-center-faq-entry-data'

type Props = {
  questions: Array<HelpCenterQuestionModel>
  faqEntryChannel?: string
  faqAccessChannel?: string
  faqEntityId?: number
}

const HelpCenterRelatedQuestions = ({
  questions,
  faqEntryChannel,
  faqAccessChannel,
  faqEntityId,
}: Props) => {
  const translate = useTranslate('help_center.related_questions')

  const { thread_id } = useBrowserNavigation().searchParams

  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  const renderRelatedQuestionItem = ({ id, path, title }: HelpCenterQuestionModel) => {
    const faqEntryUrl = urlWithParams(path, { thread_id })

    const handleUserClickRelatedQuestion = () => {
      track(
        userClickFaqRelatedQuestionEvent({
          helpCenterSessionId,
          faqEntryChannel,
          faqAccessChannel,
          targetFaqId: id,
          initialFaqId: faqEntityId,
        }),
      )
    }

    return (
      <li key={id} className="faq__related-item">
        <a href={faqEntryUrl} onClick={handleUserClickRelatedQuestion}>
          {title}
        </a>
      </li>
    )
  }

  return (
    <div className="faq__related">
      <Text as="h3" type={Text.Type.Heading} text={translate('title')} />
      <ul className="faq__related-list">{questions.map(renderRelatedQuestionItem)}</ul>
    </div>
  )
}

export default HelpCenterRelatedQuestions
